export const has = (s?: string): boolean => !!s && s.trim() !== '';
